function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { Fragment, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import LinesEllipsis from 'react-lines-ellipsis';
import moment from 'moment';
import { ClassNames } from '@emotion/core';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import Carousel from '@domain-group/fe-co-carousel';
import { PhotoIcon } from '@domain-group/fe-co-icon';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import { ListingBadges, ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { ListingInfoPill, PriceGuidePill } from '@domain-group/fe-co-allhomes-shared-components';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import { AllhomesListingBadges } from '@domain-group/fe-co-allhomes-listing-badges';
import pageWrapper from './wrappers';
import * as styles from './allhomes-search-featured-property.style';
import { Features } from './components/features';
import { MediaStats } from './components/media-stats';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BaseAllhomesSearchFeaturedProperty = _ref => {
  var _ref$listings = _ref.listings,
    propListings = _ref$listings === void 0 ? [] : _ref$listings,
    listingType = _ref.listingType,
    onAddToWatchlist = _ref.onAddToWatchlist,
    onFeaturePropertyClick = _ref.onFeaturePropertyClick,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {
      mobile: true
    } : _ref$media;
  var _ref2 = useAllhomesApi() || {},
    _ref2$toggledFeatures = _ref2.toggledFeatures,
    toggledFeatures = _ref2$toggledFeatures === void 0 ? {} : _ref2$toggledFeatures;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  var listings = propListings;
  var mobile = media.mobile,
    tablet = media.tablet,
    desktop = media.desktop;
  useEffect(() => setMounted(true), [mounted]);
  var makeListingCard = (listingObj, index) => {
    var _listingObj$listing$n, _listingObj$image;
    var hasInspection = !isEmpty(listingObj.listing.nextInspection);
    var buildBadges = function buildBadges() {
      var badges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.entries(badges).filter(_ref3 => {
        var _ref4 = _slicedToArray(_ref3, 2),
          badge = _ref4[0],
          value = _ref4[1];
        return value && ListingBadges[badge];
      }).map(_ref5 => {
        var _ref6 = _slicedToArray(_ref5, 1),
          badgeKey = _ref6[0];
        return {
          badge: badgeKey,
          label: ListingBadges[badgeKey].label,
          shortLabel: ListingBadges[badgeKey].label,
          tinyLabel: ListingBadges[badgeKey].label
        };
      });
    };
    var displayLogo = (agencyLogo, color) => {
      var containerStyle = mobile ? styles.mobileLogoBox : styles.logoBox;
      var imageStyle = mobile ? styles.mobileLogo : styles.logo;
      return ___EmotionJSX("div", {
        css: containerStyle(color)
      }, ___EmotionJSX(MultiResolutionImage, {
        src: agencyLogo,
        css: imageStyle,
        alt: ""
      }));
    };
    var displayAgentName = (agent1, agent2) => [agent1, agent2].filter(Boolean).join(' & ');
    var inspectionDate = hasInspection && ((_listingObj$listing$n = listingObj.listing.nextInspection) === null || _listingObj$listing$n === void 0 ? void 0 : _listingObj$listing$n.startdate) || undefined;
    var nextInspectionFormatted = inspectionDate && moment(inspectionDate).format('ddd D MMM, h:mm A');
    var renderPills = () => {
      var priceGuideEnabled = toggledFeatures[ToggledFeatureKey.PRICE_GUIDE];
      return (hasInspection || priceGuideEnabled) && ___EmotionJSX("div", {
        css: styles.pills
      }, hasInspection && ___EmotionJSX(ListingInfoPill, {
        label: ___EmotionJSX("span", {
          itemProp: "name"
        }, "Open"),
        details: ___EmotionJSX("span", {
          itemProp: "startDate",
          content: inspectionDate
        }, nextInspectionFormatted),
        ctaIcon: ___EmotionJSX(Fragment, null)
      }), priceGuideEnabled && listingObj.priceGuide && ___EmotionJSX(PriceGuidePill, {
        priceGuide: listingObj.priceGuide
      }));
    };
    return ___EmotionJSX("div", {
      key: listingObj.listing.id
    }, ___EmotionJSX("div", {
      css: styles.card
    }, ___EmotionJSX("div", {
      css: styles.imageColumn
    }, ___EmotionJSX("div", {
      css: styles.imageContainer
    }, ___EmotionJSX(AllhomesWatchlistButton, {
      css: styles.watchlistButton,
      listingId: listingObj.listing.id,
      onAddToWatchlist: onAddToWatchlist,
      popupStyle: tablet ? 'squeezed' : 'normal',
      inactiveColour: "white",
      noText: true
    }), ___EmotionJSX("div", null, (_listingObj$image = listingObj.image) !== null && _listingObj$image !== void 0 && _listingObj$image.highRes ? ___EmotionJSX(MultiResolutionImage, {
      src: listingObj.image.highRes,
      css: styles.propertyImage,
      alt: ""
    }) : ___EmotionJSX("div", {
      css: styles.noImageContainer
    }, ___EmotionJSX("div", {
      css: styles.noImageContent
    }, ___EmotionJSX(PhotoIcon, null), ___EmotionJSX("div", null, "Image not available")))), ___EmotionJSX("div", {
      css: styles.badges
    }, ___EmotionJSX(AllhomesListingBadges, {
      annotations: buildBadges(listingObj.listing.listingBadges),
      labelType: "short"
    })), (listingObj.listing.virtualTourUrl || listingObj.listing.videoCount > 0 || listingObj.listing.photoCount > 0) && ___EmotionJSX(MediaStats, {
      has3dTour: !isEmpty(listingObj.listing.virtualTourUrl),
      hasVideo: listingObj.listing.videoCount > 0,
      numPhotos: listingObj.listing.photoCount
    }))), ___EmotionJSX("div", {
      css: styles.detailColumn
    }, ___EmotionJSX("div", {
      css: styles.detailAddressColumn
    }, ___EmotionJSX("div", {
      css: styles.price
    }, listingObj.price), ___EmotionJSX("a", {
      css: styles.link,
      href: listingObj.url,
      onClick: () => onFeaturePropertyClick === null || onFeaturePropertyClick === void 0 ? void 0 : onFeaturePropertyClick(index + 1, listings[index])
    }, ___EmotionJSX("div", {
      css: styles.address1
    }, listingObj.address.street), ___EmotionJSX("div", {
      css: styles.address2
    }, listingObj.address.suburb, ", ", listingObj.address.state, ' ', listingObj.address.postcode)), desktop && ___EmotionJSX("div", {
      css: styles.featuresDivider
    }), ___EmotionJSX(Features, _extends({}, listingObj.features, {
      type: listingObj.listing.propertyType,
      eer: listingObj.listing.eer,
      size: listingObj.listing.floorArea,
      listingType: listingType
    })), renderPills()), ___EmotionJSX("div", {
      css: styles.agentColumn
    }, ___EmotionJSX("span", null, ___EmotionJSX("div", {
      css: styles.agentPhotos
    }, ___EmotionJSX("span", {
      css: styles.agent1Avatar
    }, ___EmotionJSX(Avatar, {
      css: styles.avatar,
      imageUrl: listingObj.agent.agentPhoto,
      isBordered: true,
      colorScheme: "light",
      size: "small"
    })), listingObj.agent.secondAgentName && ___EmotionJSX("span", {
      css: styles.agent2Avatar
    }, ___EmotionJSX(Avatar, {
      css: styles.avatar,
      imageUrl: listingObj.agent.secondAgentPhoto,
      isBordered: true,
      colorScheme: "light",
      size: "small"
    }))), ___EmotionJSX("div", {
      css: styles.agentName
    }, (mobile || tablet) && ___EmotionJSX(LinesEllipsis, {
      text: displayAgentName(listingObj.agent.agentName, listingObj.agent.secondAgentName),
      maxLine: "2",
      ellipsis: "...",
      trimRight: true,
      basedOn: "words"
    }), desktop && displayAgentName(listingObj.agent.agentName, listingObj.agent.secondAgentName)), tablet && ___EmotionJSX("div", {
      css: styles.agencyName
    }, ___EmotionJSX(LinesEllipsis, {
      text: listingObj.agent.agencyName,
      maxLine: "2",
      ellipsis: "...",
      trimRight: true,
      basedOn: "words"
    })), desktop && ___EmotionJSX("div", {
      css: styles.agencyName
    }, listingObj.agent.agencyName), (tablet || desktop) && displayLogo(listingObj.agent.agencyLogo, listingObj.agent.agencyLogoBackgroundColour)))), ___EmotionJSX("a", {
      css: styles.link,
      href: listingObj.url,
      onClick: () => onFeaturePropertyClick === null || onFeaturePropertyClick === void 0 ? void 0 : onFeaturePropertyClick(index + 1, listings[index])
    }, mobile && displayLogo(listingObj.agent.agencyLogo, listingObj.agent.agencyLogoBackgroundColour))));
  };
  if (mounted) {
    return ___EmotionJSX("section", {
      css: styles.carousel
    }, ___EmotionJSX(ClassNames, null, _ref7 => {
      var css = _ref7.css;
      return ___EmotionJSX(Carousel, {
        autoplay: listings.length > 1,
        autoplaySpeed: 5000,
        infinite: listings.length > 1,
        dots: listings.length > 1,
        dotsClass: css(styles.carouselDots),
        arrows: false
      }, listings.map(makeListingCard));
    }));
  }
  return listings.length > 0 ? ___EmotionJSX("div", {
    css: styles.fakeCarousel
  }, makeListingCard(listings[0], 0), ___EmotionJSX("ul", {
    css: styles.fakeCarouselDots
  }, listings.map(item => ___EmotionJSX("li", {
    key: item.listing.id
  }, ___EmotionJSX("button", {
    type: "button"
  }, "1"))))) : null;
};
export var AllhomesSearchFeaturedProperty = pageWrapper()(BaseAllhomesSearchFeaturedProperty);